// extracted by mini-css-extract-plugin
export default {"list":"TaskList_list__J1HBB","listItem":"TaskList_listItem__la0lI"};